module.exports = __webpack_public_path__ + "img/swap.5702bf7e.svg";